import * as MutationTypes from "./mutation-types";

export const mutations = {};
